/* eslint-disable */
import {
  Box,
  Button,
  Divider,
  Typography,
  Popover,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import bgLocale from "date-fns/locale/bg";
import enLocale from "date-fns/locale/en-GB";
import {
  convertCurrency,
  formatMoney,
  getCurrencySymbol,
  toNumberOrNull,
} from "../../utils/currency";
import { POLICY_TYPE_HEALTH, policyTypeLabel } from "../../config/domain";
import { useTranslation } from "react-i18next";
import {
  listPolicies,
  updatePolicy,
  updateInstallment,
  searchVehicle,
  deletePolicy,
} from "../../actions/amarantFields";
import { connect } from "react-redux";
import moment from "moment";
import "moment-timezone";
import { filterByProp } from "../../utils/helperFunctions";
import { AMARANT2_API_URL } from "../../config/settings";
import { toast } from "react-toastify";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PaymentIcon from "@mui/icons-material/Payment";
import ArchiveIcon from "@mui/icons-material/Archive";
import DeleteIcon from "@mui/icons-material/Delete";

// restricted contacts
const restrictedContacts = [
  "+359889335580",
  "mexusbg@gmail.com",
  "ben669@abv.bg",
  "+359894448525",
  "+359888397557",
  "+359896780237",
  "+359894448541",
  "+359889055798",
];

// List of unrestricted contacts
const unrestrictedContacts = [
  "+359889335580",
  "mexusbg@gmail.com",
  "ben669@abv.bg",
  "+359894448525",
  "+359888397557",
  "+359896780237",
  "+359894448541",
  "+359889055798",
];

const columnKeys = [
  "policies:colKind",
  "policies:colStatus",
  "policies:colCompany",
  "policies:colInsuredObject",
  "policies:colBoughtFromAmarant",
  "policies:colPolicyNumber",
  "policies:colStartDate",
  "policies:colEndDate",
  "policies:colAmount",
  "policies:colInstallmentStatus",
  "policies:colPackageType",
  "policies:colPaymentMethod",
  "policies:colDeleted",
];

const fieldNames = [
  "policyType", //string
  "state", //string
  "insuranceAgency", //string
  "insuredObject", //string
  "externalPolicy", //string
  "policyNumber", //string
  "policyStartDate", // string
  "policyEndDate", //string
  "amount", //integer
  "installmentsStatus", //string (computed)
  "package", //string
  "paymentType", //string
  "deletedAt", //date
];

class CustomDateFnsUtils extends DateFnsUtils {
  constructor(props) {
    super(props);
    this.fontFamily = "'Lexis-Medium', sans-serif";
  }
}

function PoliciesComponent({
  policies,
  listPolicies,
  customerID,
  updatePolicy,
  updateInstallment,
  searchVehicle,
  searchedVehicles: propSearchedVehicles,
  setSearchedVehicles,
  currentUser,
  deletePolicy,
}) {
  const { t, i18n } = useTranslation();
  const dateLocale = i18n.language === "bg" ? bgLocale : enLocale;
  const currencySwitchDateLocal = new Date(2026, 0, 1);
  const policyDisplayOrder =
    new Date() >= currencySwitchDateLocal ? ["EUR", "BGN"] : ["BGN", "EUR"];

  const getOtherCurrency = (currency) => (currency === "EUR" ? "BGN" : "EUR");

  const getPolicyDualAmounts = (amount, currency) => {
    const baseCurrency = currency === "EUR" ? "EUR" : "BGN";
    const baseAmount = toNumberOrNull(amount);
    if (baseAmount === null) return { EUR: null, BGN: null };

    const eur =
      baseCurrency === "EUR"
        ? baseAmount
        : convertCurrency(baseAmount, "BGN", "EUR");
    const bgn =
      baseCurrency === "BGN"
        ? baseAmount
        : convertCurrency(baseAmount, "EUR", "BGN");

    return { EUR: eur, BGN: bgn };
  };

  const getPolicyDisplayAmounts = (amount, currency) => {
    const dual = getPolicyDualAmounts(amount, currency);
    const primaryCurrency = policyDisplayOrder[0];
    const secondaryCurrency = policyDisplayOrder[1];

    return {
      primaryCurrency,
      primaryAmount: dual?.[primaryCurrency] ?? null,
      secondaryCurrency,
      secondaryAmount: dual?.[secondaryCurrency] ?? null,
    };
  };

  const formatPrimaryAmount = (amount, currency) => {
    if (
      amount === "-" ||
      amount === "" ||
      amount === null ||
      amount === undefined
    )
      return "-";
    const num = toNumberOrNull(amount);
    if (num === null) return "-";
    return `${formatMoney(num)} ${getCurrencySymbol(currency)}`;
  };

  const formatSecondaryAmount = (amount, currency) => {
    if (amount === "-" || amount === "" || amount === null || amount === undefined)
      return null;
    const num = toNumberOrNull(amount);
    if (num === null) return null;
    const otherCurrency = getOtherCurrency(currency);
    const converted = convertCurrency(num, currency, otherCurrency);
    if (converted === null) return null;
    return `≈ ${formatMoney(converted)} ${getCurrencySymbol(otherCurrency)}`;
  };
  const [filter, setFilter] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentInstallments, setCurrentInstallments] = useState([]);
  const [currentPolicy, setCurrentPolicy] = useState({
    insuredObject: "",
    client: "",
  });
  const [localSearchedVehicles, setLocalSearchedVehicles] = useState([]);

  // Dialog windows for editing
  const [openVehicleSearch, setOpenVehicleSearch] = useState(false);
  const [openStartDateEdit, setOpenStartDateEdit] = useState(false);
  const [openEndDateEdit, setOpenEndDateEdit] = useState(false);
  const [openAmountEdit, setOpenAmountEdit] = useState(false);
  const [openInstallmentEdit, setOpenInstallmentEdit] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [policyToDelete, setPolicyToDelete] = useState(null);

  const [editingPolicy, setEditingPolicy] = useState(null);
  const [editingInstallment, setEditingInstallment] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [editPremium, setEditPremium] = useState("");
  const [installmentPremium, setInstallmentPremium] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showInstallmentsInfo, setShowInstallmentsInfo] = useState(false);

  useEffect(() => {
    listPolicies({
      //customerSupportId: "6231bc7bc8696d0016d4af13",
      customerSupportId: customerID,
    });
  }, []);

  useEffect(() => {
    if (propSearchedVehicles && propSearchedVehicles.length > 0) {
      setLocalSearchedVehicles(propSearchedVehicles);
    }
  }, [propSearchedVehicles]);

  const getInstallements = (policy) => {
    if (!policy?.installments?.length) return 0;
    let paid = 0;
    policy.installments.map((install) => {
      if (install.paid === true) paid += 1;
    });
    return paid;
  };

  const handlePopoverOpen = (event, policy) => {
    if (!policy || !policy.installments) return;

    const sortedInstallments = [...policy.installments].sort((a, b) => {
      if (a.installmentNumber && b.installmentNumber) {
        return a.installmentNumber - b.installmentNumber;
      }

      const dateA = new Date(a.dueDate);
      const dateB = new Date(b.dueDate);
      return dateA - dateB;
    });

    setCurrentInstallments(sortedInstallments);
    setCurrentPolicy(policy);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleInstallmentEditOpen = (installment, policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noEditRights"));
      return;
    }

    console.log("Opening installment edit modal with:", installment);

    setEditingInstallment(installment);
    setEditingPolicy(policy);

    // Converting date to format for input field
    if (installment.dueDate) {
      try {
        let dueDateFormatted = "";

        // Check if date is in format with T (ISO string)
        if (
          typeof installment.dueDate === "string" &&
          installment.dueDate.includes("T")
        ) {
          // Parse ISO format
          const date = new Date(installment.dueDate);
          if (!isNaN(date.getTime())) {
            // Format as YYYY-MM-DD
            dueDateFormatted = date.toISOString().split("T")[0];
            console.log("ISO date parsed:", dueDateFormatted);
          }
        }
        // Check if date is in DD.MM.YYYY format
        else if (
          typeof installment.dueDate === "string" &&
          installment.dueDate.includes(".")
        ) {
          const [day, month, year] = installment.dueDate.split(".");
          if (day && month && year) {
            dueDateFormatted = `${year}-${month}-${day}`;
          }
        }
        // Try with moment as fallback
        else {
          const date = moment(installment.dueDate);
          if (date.isValid()) {
            dueDateFormatted = date.format("YYYY-MM-DD");
          }
        }

        console.log("Setting due date for input:", dueDateFormatted);
        setDueDate(dueDateFormatted);
      } catch (error) {
        console.error("Error parsing due date:", error);
        setDueDate("");
      }
    } else {
      setDueDate("");
    }

    setInstallmentPremium(installment.amount || "");
    setIsPaid(installment.paid || false);
    setOpenInstallmentEdit(true);
  };

  const handleInstallmentEditClose = () => {
    setOpenInstallmentEdit(false);
    setTimeout(() => {
      setEditingInstallment(null);
      setEditingPolicy(null);
      setDueDate("");
      setInstallmentPremium("");
      setIsPaid(false);
    }, 100);
  };

  const handleSearchVehicles = () => {
    if (!searchTerm) {
      toast.error(t("policies:enterPlateToSearch"));
      return;
    }

    searchVehicle({
      registrationNumber: searchTerm,
      onSuccess: (response) => {
        console.log("Search vehicle response:", response);

        // Check for successful response with direct vehicle object
        if (response && response._id) {
          // Response is a single vehicle
          setLocalSearchedVehicles([response]);
          setSelectedVehicle(response);
          toast.success(
            t("policies:vehicleFound", {
              plate: response.carMakeEnglish || response.licensePlate,
            })
          );
          return;
        }

        // Check for successful response with array of vehicles
        if (Array.isArray(response)) {
          setLocalSearchedVehicles(response);
          if (response.length > 0) {
            console.log("Found vehicles:", response);
            toast.success(t("policies:vehiclesFound", { count: response.length }));
          } else {
            toast.info(t("policies:noVehiclesFound"));
          }
          return;
        }

        // Check for payload in response (for compatibility with different API formats)
        if (response && response.payload) {
          if (Array.isArray(response.payload)) {
            setLocalSearchedVehicles(response.payload);
            if (response.payload.length > 0) {
              console.log("Found vehicles in payload:", response.payload);
              toast.success(t("policies:vehiclesFound", { count: response.payload.length }));
            } else {
              toast.info(t("policies:noVehiclesFound"));
            }
          } else if (response.payload._id) {
            // Payload is a single object
            setLocalSearchedVehicles([response.payload]);
            setSelectedVehicle(response.payload);
            toast.success(
              t("policies:vehicleFound", {
                plate:
                  response.payload.carMakeEnglish ||
                  response.payload.licensePlate,
              })
            );
          } else {
            toast.info(t("policies:noVehiclesFound"));
          }
          return;
        }

        // If we get here, no vehicles were found
        setLocalSearchedVehicles([]);
        toast.info(t("policies:noVehiclesFound"));
      },
      onError: (error) => {
        console.error("Search vehicle error:", error);
        toast.error(error || t("policies:vehicleSearchError"));
      },
    });
  };

  const handleSaveInstallment = () => {
    if (!editingInstallment?._id) {
      toast.error(t("policies:missingInstallmentId"));
      return;
    }

    let formattedDueDate;

    try {
      const dueDateObj = new Date(dueDate);
      dueDateObj.setHours(23, 59, 59, 999);

      if (isNaN(dueDateObj.getTime())) {
        toast.error(t("policies:invalidDueDate"));
        return;
      }

      formattedDueDate = dueDateObj.toISOString();
    } catch (e) {
      console.error("Error formatting due date:", e);
      toast.error(t("policies:invalidDueDate"));
      return;
    }

    const amount = parseFloat(installmentPremium);
    if (isNaN(amount) || amount <= 0) {
      toast.error(t("policies:enterValidAmount"));
      return;
    }

    const updatedInstallment = {
      _id: editingInstallment._id,
      dueDate: formattedDueDate,
      amount: amount,
      paid: isPaid,
    };

    updateInstallment({
      installment: updatedInstallment,
      onSuccess: () => {
        toast.success(t("policies:installmentUpdated"));
        handleInstallmentEditClose();
        listPolicies({
          customerSupportId: customerID,
        });
      },
      onError: (error) => {
        toast.error(error || t("policies:installmentUpdateError"));
      },
    });
  };

  // Fix rendering of objects in JSX
  const renderObject = (obj) => {
    if (!obj) return "-";
    if (typeof obj === "string") return obj;
    if (typeof obj === "number") return obj;
    if (typeof obj === "object") {
      if (obj._id) return obj._id;
      if (obj.name) return obj.name;
      return JSON.stringify(obj);
    }
    return "-";
  };

  // Fix moment for date formatting
  const formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    try {
      // First try to see if it's in DD.MM.YYYY format
      if (typeof dateString === "string" && dateString.includes(".")) {
        const parts = dateString.split(" ")[0].split(".");
        if (parts.length === 3) {
          return `${parts[0]}.${parts[1]}.${parts[2]}`;
        }
      }

      // If not standard format, use moment
      const date = moment(dateString);
      return date.isValid() ? date.format("DD.MM.YYYY") : "-";
    } catch (e) {
      console.error("Error formatting date:", e);
      return "-";
    }
  };

  // Format datetime fields
  const formatDateTime = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    try {
      const date = moment(dateString);
      return date.isValid() ? date.format("DD.MM.YYYY HH:mm") : "-";
    } catch (e) {
      console.error("Error formatting datetime:", e);
      return "-";
    }
  };

  // Function to check if vehicle is archived
  const isVehicleArchived = (vehicle) => {
    if (!vehicle) return false;

    // Check vehicleArchivedAt for archived vehicle - if NOT null, it's archived
    if (typeof vehicle === "object" && vehicle.vehicleArchivedAt !== null)
      return true;

    // For compatibility with old data - check other properties too
    if (vehicle.isArchived === true) return true;
    if (vehicle.archived === true) return true;
    if (vehicle.status === "archived") return true;
    if (vehicle.status === "inactive") return true;

    return false;
  };

  // CHANGE: Removed access restrictions 
  const isUnrestricted = true;

  // New functions for opening modals for editing individual fields
  const handleVehicleEditOpen = (policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noEditRights"));
      return;
    }

    if (!policy.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    setEditingPolicy(policy);
    setSearchTerm("");
    setLocalSearchedVehicles([]);
    setSelectedVehicle(null);
    setOpenVehicleSearch(true);
  };

  const handleStartDateEditOpen = (policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noEditRights"));
      return;
    }

    if (!policy.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    setEditingPolicy(policy);

    try {
      // Format the start date
      if (policy.policyStartDate) {
        // Check if the date is in DD.MM.YYYY format
        const parts = policy.policyStartDate.split(" ")[0].split(".");
        if (parts.length === 3) {
          // Convert from DD.MM.YYYY to YYYY-MM-DD for the input field
          setStartDate(`${parts[2]}-${parts[1]}-${parts[0]}`);
        } else {
          // Fallback with moment
          const date = moment(policy.policyStartDate);
          if (date.isValid()) {
            setStartDate(date.format("YYYY-MM-DD"));
          } else {
            setStartDate("");
          }
        }
      } else {
        setStartDate("");
      }
    } catch (e) {
      console.error("Error formatting start date:", e);
      setStartDate("");
    }

    setOpenStartDateEdit(true);
  };

  const handleEndDateEditOpen = (policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noEditRights"));
      return;
    }

    if (!policy.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    setEditingPolicy(policy);

    try {
      // Format the end date
      if (policy.policyEndDate) {
        // Check if the date is in DD.MM.YYYY format
        const parts = policy.policyEndDate.split(" ")[0].split(".");
        if (parts.length === 3) {
          // Convert from DD.MM.YYYY to YYYY-MM-DD for the input field
          setEndDate(`${parts[2]}-${parts[1]}-${parts[0]}`);
        } else {
          // Fallback with moment
          const date = moment(policy.policyEndDate);
          if (date.isValid()) {
            setEndDate(date.format("YYYY-MM-DD"));
          } else {
            setEndDate("");
          }
        }
      } else {
        setEndDate("");
      }
    } catch (e) {
      console.error("Error formatting end date:", e);
      setEndDate("");
    }

    setOpenEndDateEdit(true);
  };

  const handleAmountEditOpen = (policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noEditRights"));
      return;
    }

    if (!policy.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    setEditingPolicy(policy);
    setEditPremium(policy.amount || "");
    setOpenAmountEdit(true);
  };

  // Add reset functions for all modal states
  const resetVehicleSearchState = () => {
    setOpenVehicleSearch(false);
    setTimeout(() => {
      setSearchTerm("");
      setLocalSearchedVehicles([]);
      setSelectedVehicle(null);
      setEditingPolicy(null);
    }, 100);
  };

  const resetStartDateEditState = () => {
    setOpenStartDateEdit(false);
    setTimeout(() => {
      setStartDate("");
      setEditingPolicy(null);
    }, 100);
  };

  const resetEndDateEditState = () => {
    setOpenEndDateEdit(false);
    setTimeout(() => {
      setEndDate("");
      setEditingPolicy(null);
    }, 100);
  };

  const resetAmountEditState = () => {
    setOpenAmountEdit(false);
    setTimeout(() => {
      setEditPremium("");
      setEditingPolicy(null);
    }, 100);
  };

  const resetInstallmentsInfoState = () => {
    setShowInstallmentsInfo(false);
    setTimeout(() => {
      setCurrentInstallments([]);
      setEditingPolicy(null);
    }, 100);
  };

  const resetInstallmentsEditState = () => {
    setOpenInstallmentEdit(false);
    setTimeout(() => {
      setDueDate("");
      setInstallmentPremium("");
      setIsPaid(false);
      setEditingInstallment(null);
      setEditingPolicy(null);
    }, 100);
  };

  // Update save functions with corresponding reset functions

  // Function to save vehicle
  const handleSaveVehicle = () => {
    if (!editingPolicy?.databaseId) {
      toast.error(t("policies:missingPolicyId"));
      return;
    }

    if (!editingPolicy?.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    const vehicleId = selectedVehicle?._id;
    if (!vehicleId) {
      toast.error(t("policies:missingVehicleId"));
      return;
    }

    const updatedPolicy = {
      _id: editingPolicy.databaseId,
      vehicle: vehicleId,
    };

    console.log("Updating policy vehicle:", updatedPolicy);

    updatePolicy({
      policy: updatedPolicy,
      onSuccess: () => {
        toast.success(t("policies:vehicleUpdated"));
        resetVehicleSearchState();
        listPolicies({
          customerSupportId: customerID,
        });
      },
      onError: (error) => {
        toast.error(error || t("policies:policyUpdateError"));
      },
    });
  };

  // Function to save start date
  const handleSaveStartDate = () => {
    if (!editingPolicy?.databaseId) {
      toast.error(t("policies:missingPolicyId"));
      return;
    }

    if (!editingPolicy?.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    if (!startDate) {
      toast.error(t("policies:missingStartDate"));
      return;
    }

    let formattedStartDate;

    try {
      // Create startDate from string YYYY-MM-DD and set start of day
      const startDateObj = new Date(startDate);
      startDateObj.setHours(0, 0, 0, 0);

      if (isNaN(startDateObj.getTime())) {
        toast.error(t("policies:invalidStartDate"));
        return;
      }

      // Convert to ISO string
      formattedStartDate = startDateObj.toISOString();
      console.log("Formatted start date ISO:", formattedStartDate);
    } catch (e) {
      console.error("Error formatting start date:", e);
      toast.error(t("policies:invalidStartDate"));
      return;
    }

    const updatedPolicy = {
      _id: editingPolicy.databaseId,
      policyStartDate: formattedStartDate,
    };

    console.log("Updating policy start date:", updatedPolicy);

    updatePolicy({
      policy: updatedPolicy,
      onSuccess: () => {
        toast.success(t("policies:startDateUpdated"));
        resetStartDateEditState();
        listPolicies({
          customerSupportId: customerID,
        });
      },
      onError: (error) => {
        toast.error(error || t("policies:policyUpdateError"));
      },
    });
  };

  // Function to save end date
  const handleSaveEndDate = () => {
    if (!editingPolicy?.databaseId) {
      toast.error(t("policies:missingPolicyId"));
      return;
    }

    if (!editingPolicy?.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    if (!endDate) {
      toast.error(t("policies:missingEndDate"));
      return;
    }

    let formattedEndDate;

    try {
      // Create endDate from string YYYY-MM-DD and set end of day
      const endDateObj = new Date(endDate);
      endDateObj.setHours(23, 59, 59, 999);

      if (isNaN(endDateObj.getTime())) {
        toast.error(t("policies:invalidEndDate"));
        return;
      }

      // Convert to ISO string
      formattedEndDate = endDateObj.toISOString();
      console.log("Formatted end date ISO:", formattedEndDate);
    } catch (e) {
      console.error("Error formatting end date:", e);
      toast.error(t("policies:invalidEndDate"));
      return;
    }

    const updatedPolicy = {
      _id: editingPolicy.databaseId,
      policyEndDate: formattedEndDate,
    };

    console.log("Updating policy end date:", updatedPolicy);

    updatePolicy({
      policy: updatedPolicy,
      onSuccess: () => {
        toast.success(t("policies:endDateUpdated"));
        resetEndDateEditState();
        listPolicies({
          customerSupportId: customerID,
        });
      },
      onError: (error) => {
        toast.error(error || t("policies:policyUpdateError"));
      },
    });
  };

  // Function to save amount
  const handleSaveAmount = () => {
    if (!editingPolicy?.databaseId) {
      toast.error(t("policies:missingPolicyId"));
      return;
    }

    if (!editingPolicy?.policyNumber) {
      toast.error(t("policies:policyNoNumber"));
      return;
    }

    // Check for valid amount
    const amount = parseFloat(editPremium);
    if (isNaN(amount) || amount <= 0) {
      toast.error(t("policies:enterValidAmount"));
      return;
    }

    const updatedPolicy = {
      _id: editingPolicy.databaseId,
      amount: amount,
    };

    console.log("Updating policy amount:", updatedPolicy);

    updatePolicy({
      policy: updatedPolicy,
      onSuccess: () => {
        toast.success(t("policies:amountUpdated"));
        resetAmountEditState();
        listPolicies({
          customerSupportId: customerID,
        });
      },
      onError: (error) => {
        toast.error(error || t("policies:policyUpdateError"));
      },
    });
  };

  // Format payment type
  const formatPaymentType = (paymentType) => {
    if (!paymentType || paymentType === "-") return "-";

    switch (paymentType.toLowerCase()) {
      case "card":
        return t("policies:pmCard");
      case "ondelivery":
      case "delivery":
        return t("policies:pmCod");
      case "cash":
        return t("policies:pmCash");
      case "bank_transfer":
      case "banktransfer":
        return t("policies:pmTransfer");
      default:
        return paymentType;
    }
  };

  // Show installments information
  const handleShowInstallmentsInfo = (policy) => {
    if (!policy) {
      toast.error(t("policies:noPolicySelected"));
      return;
    }

    // Създаваме копие на policy с подредени вноски
    const policyWithSortedInstallments = {
      ...policy,
      installments: policy.installments
        ? [...policy.installments].sort((a, b) => {
            if (a.installmentNumber && b.installmentNumber) {
              return a.installmentNumber - b.installmentNumber;
            }

            // Ако нямаме номер на вноска, сортираме по дата на падеж
            const dateA = new Date(a.dueDate);
            const dateB = new Date(b.dueDate);
            return dateA - dateB;
          })
        : [],
    };

    setEditingPolicy(policyWithSortedInstallments);
    setShowInstallmentsInfo(true);
  };

  // Handle delete policy
  const handleDeletePolicy = (policy) => {
    if (!isUnrestricted) {
      toast.error(t("policies:noDeleteRights"));
      return;
    }

    console.log("Policy object for deletion:", policy);

    if (!policy) {
      toast.error(t("policies:invalidPolicyDelete"));
      return;
    }

    // Използваме _id или databaseId, в зависимост от това кое съществува
    const policyId = policy._id || policy.databaseId;

    if (!policyId) {
      toast.error(t("policies:invalidPolicyDeleteNoId"));
      return;
    }

    // Добавяме _id към обекта ако го няма, но има databaseId
    const policyWithId = {
      ...policy,
      _id: policyId,
    };

    setPolicyToDelete(policyWithId);
    setOpenDeleteConfirm(true);
  };

  // Confirm delete policy
  const confirmDeletePolicy = () => {
    if (!policyToDelete) {
      toast.error(t("policies:invalidPolicyDelete"));
      setOpenDeleteConfirm(false);
      return;
    }

    console.log("Confirming deletion for policy:", policyToDelete);

    // Използваме _id или databaseId, в зависимост от това кое съществува
    const policyId = policyToDelete._id || policyToDelete.databaseId;

    if (!policyId) {
      toast.error(t("policies:invalidPolicyDeleteNoId"));
      setOpenDeleteConfirm(false);
      return;
    }

    deletePolicy({
      policyId: policyId,
      onSuccess: () => {
        toast.success(t("policies:policyDeleted"));
        listPolicies({
          customerSupportId: customerID,
        });
        setOpenDeleteConfirm(false);
      },
      onError: (error) => {
        toast.error(error || t("policies:policyDeleteError"));
        setOpenDeleteConfirm(false);
      },
    });
  };

  // Cancel delete policy
  const cancelDeletePolicy = () => {
    setPolicyToDelete(null);
    setOpenDeleteConfirm(false);
  };

  // Update column width calculation to make columns more evenly distributed
  const getColumnWidth = () => {
    return `${100 / columnKeys.length}%`;
  };

  return (
    <>
      <div
        className={styles["blurred-background"]}
        id="blurred"
        style={{ display: "none" }}
      >
        <div className={styles["propertyModal"]}>
          <div className={styles["headerModal"]}>
            <b style={{ textTransform: "uppercase", fontSize: "16px" }}>
              {t("policies:insuranceDetails")}
            </b>
            <p
              style={{ color: "#C6C6DE", cursor: "pointer" }}
              onClick={() => {
                document.getElementById("blurred").style.display = "none";
              }}
            >
              {t("hide")} {`>`}
            </p>
          </div>
          <div className={styles["bodyModal"]}>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>{t("policies:address")}</p>
              <b>{currentPolicy?.insuredObject}</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>{t("policies:propertySize")}</p>
              <b>---</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:buildYear")}
              </p>
              <b>---</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:damageLast12")}
              </p>
              <b>{t("no")}</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>{t("policies:securityMeasures")}</p>
              <b>---</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>{t("policies:fireMeasures")}</p>
              <b>---</b>
            </div>
            <div className={styles["modalLine"]}>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:ownerData")}
              </p>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:firstName")}{" "}
                <b>
                  {currentPolicy?.client && currentPolicy?.client.split(" ")[0]}
                </b>
              </p>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:middleName")}{" "}
                <b>
                  {currentPolicy?.client && currentPolicy?.client.split(" ")[1]}
                </b>
              </p>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:lastName")}{" "}
                <b>
                  {currentPolicy?.client && currentPolicy?.client.split(" ")[2]}
                </b>
              </p>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:egn")} <b>{currentPolicy?.clientIdentifier}</b>
              </p>
              <p style={{ marginBottom: "0.5%" }}>
                {t("policies:address")} <b>{currentPolicy?.insuredObject}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          height: window.innerWidth < 900 ? "120%" : "100%",
          width: "100%",
          overflowX: "scroll",
          overflowY: "auto",
        }}
      >
        {window.innerWidth < 900 ? (
          <React.Fragment>
            <div
              className={styles["tabs-container"]}
              style={{ padding: "0px" }}
            >
              {Array.isArray(policies) && policies.length > 0 ? (
                policies.map((policy, i) => {
                  return (
                    <div
                      className={styles["row-container"]}
                      style={{
                        marginTop: "5%",
                        display: "block",
                        height: "unset",
                      }}
                      key={i}
                    >
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[0])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {policyTypeLabel(policy?.policyType, t)}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[1])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor:
                                policy?.state === "active" ? "green" : "red",
                              mr: 1,
                            }}
                          />
                          <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {policy?.state === "active" ? t("policies:stActive") : t("policies:stExpired")}
                          </b>
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[2])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {policy?.insuranceAgency}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[3])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {/* Мобилен изглед - текст в колоната "Застрахован обект" */}
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <b
                              style={{
                                marginBottom: "1%",
                                fontSize: "14px",
                                color:
                                  (policy?.vehicleArchivedAt &&
                                    policy?.vehicleArchivedAt !== "-") ||
                                  (policy?.insuredObject &&
                                    isVehicleArchived(policy.insuredObject))
                                    ? "#757575"
                                    : "inherit",
                              }}
                            >
                              {renderObject(policy?.insuredObject)}
                            </b>
                            {((policy?.vehicleArchivedAt &&
                              policy?.vehicleArchivedAt !== "-") ||
                              (policy?.insuredObject &&
                                isVehicleArchived(policy.insuredObject))) && (
                              <Tooltip title={t("policies:archivedVehicle")} arrow>
                                <ArchiveIcon
                                  fontSize="small"
                                  sx={{
                                    ml: 0.5,
                                    color: "#757575",
                                    fontSize: "18px",
                                    verticalAlign: "middle",
                                    display: "inline-block",
                                  }}
                                />
                              </Tooltip>
                            )}
                            {policy?.policyNumber &&
                              policy.policyNumber !== "-" &&
                              policy?.policyType !== POLICY_TYPE_HEALTH &&
                              isUnrestricted && (
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F9FAFB",
                                    "&:hover": { backgroundColor: "#F9FAFB" },
                                  }}
                                  onClick={() => handleVehicleEditOpen(policy)}
                                >
                                  <EditIcon style={{ color: "#0DC1CE" }} />
                                </IconButton>
                              )}
                          </Box>
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[4])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {(![null, undefined, '-', ''].includes(policy?.ordered) || ![null, undefined, '-', ''].includes(policy?.customerSupport)) ? t("yes") : t("no")}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[5])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {policy?.policyNumber || "-"}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[6])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {formatDate(policy?.policyStartDate)}
                          </b>
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleStartDateEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[7])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {formatDate(policy?.policyEndDate)}
                          </b>
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleEndDateEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[8])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                            {(() => {
                              const display = getPolicyDisplayAmounts(
                                policy?.amount,
                                policy?.currency
                              );
                              return formatPrimaryAmount(
                                display?.primaryAmount,
                                display?.primaryCurrency
                              );
                            })()}
                          </b>
                          {(() => {
                            const display = getPolicyDisplayAmounts(
                              policy?.amount,
                              policy?.currency
                            );
                            return toNumberOrNull(display?.secondaryAmount) !==
                              null ? (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ ml: 1 }}
                              >
                                {`≈ ${formatMoney(
                                  display?.secondaryAmount
                                )} ${getCurrencySymbol(
                                  display?.secondaryCurrency
                                )}`}
                              </Typography>
                            ) : null;
                          })()}
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleAmountEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[9])}
                        </p>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor:
                                policy?.installments?.length > 0
                                  ? getInstallements(policy) ===
                                    policy?.installments?.length
                                    ? "green"
                                    : "orange"
                                  : "grey",
                              mr: 1,
                            }}
                          />
                          <b
                            style={{
                              cursor:
                                policy?.installments?.length > 0
                                  ? "pointer"
                                  : "default",
                              marginRight: "8px",
                            }}
                            onClick={(e) => handlePopoverOpen(e, policy)}
                          >
                            {policy?.installments?.length > 0
                              ? `${getInstallements(policy)}/${
                                  policy.installments.length
                                }`
                              : t("policies:noInstallments")}
                          </b>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditingPolicy(policy);
                              setShowInstallmentsInfo(true);
                            }}
                            sx={{ ml: 0, p: 0.3 }}
                          >
                            <InfoOutlinedIcon
                              fontSize="small"
                              sx={{ fontSize: "18px" }}
                            />
                          </IconButton>
                        </Box>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[10])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {policy?.package}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[11])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {formatPaymentType(policy.paymentType)}
                        </b>
                      </div>
                      <Divider />
                      <div className={styles["mobile-box"]}>
                        <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                          {t(columnKeys[12])}
                        </p>
                        <b
                          style={{
                            marginBottom: "1%",
                            fontSize: "14px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {(!policy?.deletedAt || policy?.deletedAt === '-') ? t("no") : t("yes")}
                        </b>
                      </div>
                      <Divider />
                    </div>
                  );
                })
              ) : (
                <Typography sx={{ textAlign: "center", p: 2 }}>
                  {t("policies:noPolicies")}
                </Typography>
              )}
            </div>
          </React.Fragment>
        ) : (
          // CHANGE: Added wrapper with minWidth to prevent column compression and enable horizontal scroll
          <div style={{ minWidth: "1600px", width: "100%" }}>
            <div className={styles["columns-container"]}>
              <div
                className={styles["upper-names"]}
                style={{
                  width: "100%",
                  minWidth: "1600px",
                }}
              >
                {columnKeys.map((column, i) => (
                  <div
                    className={`${styles["name-icon"]}`}
                    key={i}
                    style={{
                      width: getColumnWidth(),
                      textAlign: "left",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      paddingTop: "8px",
                      paddingBottom: "8px",
                      cursor: "pointer",
                      minHeight: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => {
                      if (filter === i.toString()) {
                        setFilter(`reverse${i}`);
                      } else {
                        setFilter(i.toString());
                      }
                    }}
                    >
                      <p style={{
                        margin: 0,
                        fontWeight: "bold",
                        fontSize: "14px",
                        lineHeight: "1.2",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        textAlign: "center"
                      }}>{t(column)}</p>
                    </div>
                ))}
              </div>
            </div>
            <div
              className={styles["tabs-container"]}
              style={{ 
                width: "100%",
                minWidth: "1400px"
              }}
            >
              {Array.isArray(policies) && policies.length > 0 ? (
                filterByProp(policies, filter, fieldNames).map((policy, i) => {
                  if (!policy) return null;
                  return (
                    <div
                      className={styles["row-container"]}
                      style={{
                        width: "100%",
                        minWidth: "1600px",
                        padding: "8px 0",
                        minHeight: "60px",
                        height: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      key={i}
                    >
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <b>{policyTypeLabel(policy?.policyType, t)}</b>
                          {policy?.policyNumber &&
                            policy?.databaseId &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                  ml: 1,
                                }}
                                onClick={() => handleDeletePolicy(policy)}
                              >
                                <DeleteIcon style={{ color: "#f44336" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Box
                            sx={{
                              width: 10,
                              height: 10,
                              borderRadius: "50%",
                              backgroundColor:
                                policy?.state === "active" ? "green" : "red",
                              mr: 1,
                            }}
                          />
                          <b>
                            {policy?.state === "active" ? t("policies:stActive") : t("policies:stExpired")}
                          </b>
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>{renderObject(policy?.insuranceAgency)}</b>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "4px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <b
                            style={{
                              color:
                                (policy?.vehicleArchivedAt &&
                                  policy?.vehicleArchivedAt !== "-") ||
                                (policy?.insuredObject &&
                                  isVehicleArchived(policy.insuredObject))
                                  ? "#757575"
                                  : "inherit",
                            }}
                          >
                            {renderObject(policy?.insuredObject)}
                          </b>
                          {((policy?.vehicleArchivedAt &&
                            policy?.vehicleArchivedAt !== "-") ||
                            (policy?.insuredObject &&
                              isVehicleArchived(policy.insuredObject))) && (
                            <Tooltip title={t("policies:archivedVehicle")} arrow>
                              <ArchiveIcon
                                fontSize="small"
                                sx={{
                                  ml: 0.5,
                                  color: "#757575",
                                  fontSize: "14px",
                                  verticalAlign: "middle",
                                  display: "inline-block",
                                }}
                              />
                            </Tooltip>
                          )}
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleVehicleEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>
                          {(![null, undefined, '-', ''].includes(policy?.ordered) || ![null, undefined, '-', ''].includes(policy?.customerSupport)) ? t("yes") : t("no")}
                        </b>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>{policy?.policyNumber}</b>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0",
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <b>{formatDate(policy?.policyStartDate)}</b>
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleStartDateEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <b>{formatDate(policy?.policyEndDate)}</b>
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleEndDateEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              lineHeight: 1.1,
                            }}
                          >
                            {(() => {
                              const display = getPolicyDisplayAmounts(
                                policy?.amount,
                                policy?.currency
                              );

                              return (
                                <>
                                  <b>
                                    {formatPrimaryAmount(
                                      display?.primaryAmount,
                                      display?.primaryCurrency
                                    )}
                                  </b>
                                  {toNumberOrNull(display?.secondaryAmount) !==
                                    null && (
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      {`≈ ${formatMoney(
                                        display?.secondaryAmount
                                      )} ${getCurrencySymbol(
                                        display?.secondaryCurrency
                                      )}`}
                                    </Typography>
                                  )}
                                </>
                              );
                            })()}
                          </Box>
                          {policy?.policyNumber &&
                            policy.policyNumber !== "-" &&
                            policy?.policyType !== POLICY_TYPE_HEALTH &&
                            isUnrestricted && (
                              <IconButton
                                size="small"
                                sx={{
                                  backgroundColor: "#F9FAFB",
                                  "&:hover": { backgroundColor: "#F9FAFB" },
                                }}
                                onClick={() => handleAmountEditOpen(policy)}
                              >
                                <EditIcon style={{ color: "#0DC1CE" }} />
                              </IconButton>
                            )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          {policy?.installments?.length > 0 ? (
                            <>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditingPolicy(policy);
                                  setShowInstallmentsInfo(true);
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    backgroundColor:
                                      policy?.installments?.every(
                                        (i) => i.paid === true
                                      )
                                        ? "green"
                                        : getInstallements(policy) > 0
                                        ? "orange"
                                        : "grey",
                                    mr: 1,
                                  }}
                                />
                                <b>
                                  {getInstallements(policy)}/
                                  {policy?.installments?.length}
                                </b>
                              </Box>
                              {policy?.policyNumber && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePopoverOpen(e, policy);
                                  }}
                                  sx={{ ml: 0.5, p: 0.5 }}
                                >
                                  <InfoIcon
                                    fontSize="small"
                                    color="primary"
                                    sx={{ fontSize: "18px" }}
                                  />
                                </IconButton>
                              )}
                            </>
                          ) : (
                            <b>-</b>
                          )}
                        </Box>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>{policy?.package}</b>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>{formatPaymentType(policy?.paymentType)}</b>
                      </div>
                      <Divider
                        style={{
                          backgroundColor: "#D3D3D3",
                          height: "65%",
                        }}
                        orientation="vertical"
                      />
                      <div
                        className={styles["data"]}
                        style={{
                          padding: "2px 0", // Намаляване от 4px на 2px
                          width: getColumnWidth(),
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          paddingLeft: "8px", // Increased spacing between columns
                          paddingRight: "8px",
                        }}
                      >
                        <b>{(!policy?.deletedAt || policy?.deletedAt === '-') ? t("no") : t("yes")}</b>
                      </div>
                    </div>
                  );
                })
              ) : (
                <Typography sx={{ textAlign: "center", p: 2 }}>
                  {t("policies:noPolicies")}
                </Typography>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Popover for installments */}
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box sx={{ padding: 2, maxWidth: "600px" }}>
          <Typography variant="h6" sx={{ marginBottom: 2, fontSize: "1rem" }}>
            {t("policies:installments")}
          </Typography>
          <div className={styles["modalDiv"]}>
            <div style={{ marginBottom: "2%" }}>
              <div style={{ marginBottom: "2%" }}></div>
              {currentInstallments && currentInstallments.length ? (
                <div className={styles["scrollLongTable"]}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "0.5fr 1.5fr 1fr 1fr",
                      gap: 2,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:instNo")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:dueDate")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:colAmount")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:colStatus")}
                    </Typography>

                    {currentInstallments.map((installment, i) => (
                      <React.Fragment key={i}>
                        <Typography variant="body2">
                          {installment.installmentNumber || i + 1}
                        </Typography>
                        <Typography variant="body2">
                          {formatDate(installment.dueDate)}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          {(() => {
                            const display = getPolicyDisplayAmounts(
                              installment.amount,
                              installment?.currency
                            );
                            return (
                              <>
                                <Typography variant="body2">
                                  {formatPrimaryAmount(
                                    display?.primaryAmount,
                                    display?.primaryCurrency
                                  )}
                                </Typography>
                                {toNumberOrNull(display?.secondaryAmount) !==
                                  null && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {`≈ ${formatMoney(
                                      display?.secondaryAmount
                                    )} ${getCurrencySymbol(
                                      display?.secondaryCurrency
                                    )}`}
                                  </Typography>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                              sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: installment.paid
                                  ? "green"
                                  : "orange",
                                mr: 1,
                              }}
                            />
                            <Typography variant="body2">
                              {installment.paid ? t("policies:stPaid") : t("policies:stUnpaid")}
                            </Typography>
                          </Box>
                          {currentPolicy?.policyNumber && isUnrestricted && (
                            <IconButton
                              size="small"
                              sx={{
                                backgroundColor: "#F9FAFB",
                                "&:hover": { backgroundColor: "#F9FAFB" },
                              }}
                              onClick={() => {
                                const installmentToEdit = installment;
                                const policyToEdit = currentPolicy;
                                handlePopoverClose();
                                if (policyToEdit?.policyNumber) {
                                  setTimeout(() => {
                                    handleInstallmentEditOpen(
                                      installmentToEdit,
                                      policyToEdit
                                    );
                                  }, 100);
                                } else {
                                  toast.error(
                                    t("policies:policyNoNumber")
                                  );
                                }
                              }}
                            >
                              <EditIcon style={{ color: "#0DC1CE" }} />
                            </IconButton>
                          )}
                        </Box>
                      </React.Fragment>
                    ))}
                  </Box>
                </div>
              ) : (
                <div>{t("policies:noInstallments")}</div>
              )}
            </div>
          </div>
        </Box>
      </Popover>

      {/* Dialog for editing installment */}
      <Dialog
        open={openInstallmentEdit}
        onClose={resetInstallmentsEditState}
        aria-labelledby="edit-installment-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">
              {t("policies:editInstallment", { n: editingInstallment?.number || "" })}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={1}>
            <Typography variant="subtitle1" gutterBottom>
              {t("policies:dueDateLabel")}{" "}
              {editingInstallment?.dueDate
                ? formatDate(editingInstallment.dueDate)
                : t("policies:notSet")}
            </Typography>

            <MuiPickersUtilsProvider
              utils={CustomDateFnsUtils}
              locale={dateLocale}
            >
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd.MM.yyyy"
                margin="normal"
                id="due-date-picker"
                label={t("policies:dueDate")}
                value={dueDate ? new Date(dueDate) : null}
                onChange={(date) => {
                  if (date) {
                    const year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    let day = date.getDate();

                    month = month < 10 ? `0${month}` : month;
                    day = day < 10 ? `0${day}` : day;

                    setDueDate(`${year}-${month}-${day}`);
                  } else {
                    setDueDate(null);
                  }
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                PopoverProps={{
                  PaperProps: {
                    style: {
                      fontFamily: "'Lexis-Medium', sans-serif",
                    },
                  },
                  disableEnforceFocus: true,
                  disableRestoreFocus: true,
                  disablePortal: false,
                  container: document.body,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  "data-calendar-container": "true",
                }}
                autoOk
                inputVariant="outlined"
                fullWidth
                InputProps={{
                  style: {
                    textAlign: "left",
                    fontFamily: "'Lexis-Medium', sans-serif",
                  },
                }}
                InputLabelProps={{
                  style: { fontFamily: "'Lexis-Medium', sans-serif" },
                }}
                maxDate={new Date("2099-12-31")}
              />
            </MuiPickersUtilsProvider>

            <TextField
              label={t("policies:installmentAmount")}
              type="number"
              value={installmentPremium || ""}
              onChange={(e) => setInstallmentPremium(e.target.value)}
              fullWidth
              margin="normal"
              required
              helperText={(() => {
                const baseCurrency =
                  editingInstallment?.currency === "EUR" ||
                  editingPolicy?.currency === "EUR"
                    ? "EUR"
                    : "BGN";
                const dual = getPolicyDualAmounts(installmentPremium, baseCurrency);
                const primary = policyDisplayOrder[0];
                const secondary = policyDisplayOrder[1];
                const primaryAmount = dual?.[primary];
                const secondaryAmount = dual?.[secondary];
                if (toNumberOrNull(primaryAmount) === null) return "";
                if (toNumberOrNull(secondaryAmount) === null) return "";
                return `≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(secondary)}`;
              })()}
              InputProps={{
                style: { textAlign: "left" },
                endAdornment: (
                  <InputAdornment position="end">
                    {getCurrencySymbol(
                      editingInstallment?.currency === "EUR" ||
                        editingPolicy?.currency === "EUR"
                        ? "EUR"
                        : "BGN"
                    )}
                  </InputAdornment>
                ),
              }}
            />

            <FormControl fullWidth margin="normal">
              <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
                {t("policies:paymentStatus")}
              </Typography>
              <RadioGroup
                value={isPaid ? "paid" : "unpaid"}
                onChange={(e) => setIsPaid(e.target.value === "paid")}
                row
                style={{ paddingLeft: "30px" }}
              >
                <FormControlLabel
                  value="paid"
                  control={<Radio color="primary" />}
                  label={t("policies:stPaid")}
                  style={{ marginRight: "20px" }}
                />
                <FormControlLabel
                  value="unpaid"
                  control={<Radio color="primary" />}
                  label={t("policies:stUnpaid")}
                />
              </RadioGroup>
            </FormControl>

            <Box
              mt={2}
              p={1}
              sx={{ bgcolor: "background.default", borderRadius: 1 }}
            >
              <Typography variant="body2" color="textSecondary">
                {t("policies:policyLabel", { number: editingPolicy?.policyNumber || "" })}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={resetInstallmentsEditState}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={handleSaveInstallment}
            style={{
              backgroundColor: "#0DC1CE",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
          >
            {t("policies:save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for showing installments info */}
      {showInstallmentsInfo && (
        <Dialog
          open={showInstallmentsInfo}
          onClose={resetInstallmentsInfoState}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="h6">{t("policies:installmentsInfo")}</Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {t("policies:policyLabel", {
                  number:
                    editingPolicy?.policyNumber || t("policies:noNumber"),
                })}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
              {editingPolicy?.installments?.length > 0 ? (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {t("policies:totalInstallments")}{" "}
                    <strong>{editingPolicy?.installments?.length}</strong> |
                    {t("policies:paidLabel")} <strong>{getInstallements(editingPolicy)}</strong>{" "}
                    | {t("policies:totalAmount")}{" "}
                    {(() => {
                      const display = getPolicyDisplayAmounts(
                        editingPolicy?.amount,
                        editingPolicy?.currency
                      );
                      return (
                        <>
                          <strong>
                            {formatPrimaryAmount(
                              display?.primaryAmount,
                              display?.primaryCurrency
                            )}
                          </strong>
                          {toNumberOrNull(display?.secondaryAmount) !== null && (
                            <Typography
                              component="span"
                              variant="caption"
                              color="text.secondary"
                              sx={{ ml: 1 }}
                            >
                              {`≈ ${formatMoney(
                                display?.secondaryAmount
                              )} ${getCurrencySymbol(display?.secondaryCurrency)}`}
                            </Typography>
                          )}
                        </>
                      );
                    })()}
                  </Typography>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "0.5fr 1fr 1fr 1fr 1fr 0.7fr",
                      gap: 2,
                      mt: 1,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:instNo")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:dueDate")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:createdOn")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:paymentDate")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:colAmount")}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                      {t("policies:colStatus")}
                    </Typography>
                    {editingPolicy?.installments?.map((installment, index) => (
                      <React.Fragment key={index}>
                        <Typography variant="body2">
                          {installment.installmentNumber || index + 1}
                        </Typography>
                        <Typography variant="body2">
                          {formatDate(installment.dueDate)}
                        </Typography>
                        <Typography variant="body2">
                          {formatDateTime(installment.createdAt || "-")}
                        </Typography>
                        <Typography variant="body2">
                          {formatDateTime(installment.paymentDate || "-")}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          {(() => {
                            const display = getPolicyDisplayAmounts(
                              installment.amount,
                              installment?.currency
                            );
                            return (
                              <>
                                <Typography variant="body2">
                                  {formatPrimaryAmount(
                                    display?.primaryAmount,
                                    display?.primaryCurrency
                                  )}
                                </Typography>
                                {toNumberOrNull(display?.secondaryAmount) !==
                                  null && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {`≈ ${formatMoney(
                                      display?.secondaryAmount
                                    )} ${getCurrencySymbol(
                                      display?.secondaryCurrency
                                    )}`}
                                  </Typography>
                                )}
                              </>
                            );
                          })()}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                              sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: installment.paid
                                  ? "green"
                                  : "orange",
                                mr: 1,
                              }}
                            />
                            <Typography variant="body2">
                              {installment.paid ? t("policies:stPaid") : t("policies:stUnpaid")}
                            </Typography>
                          </Box>
                          {editingPolicy?.policyNumber && isUnrestricted && (
                            <IconButton
                              size="small"
                              sx={{
                                backgroundColor: "#F9FAFB",
                                "&:hover": { backgroundColor: "#F9FAFB" },
                              }}
                              onClick={() => {
                                resetInstallmentsInfoState();
                                setTimeout(() => {
                                  handleInstallmentEditOpen(
                                    installment,
                                    editingPolicy
                                  );
                                }, 100);
                              }}
                            >
                              <EditIcon style={{ color: "#0DC1CE" }} />
                            </IconButton>
                          )}
                        </Box>
                      </React.Fragment>
                    ))}
                  </Box>
                </Box>
              ) : (
                <Typography variant="body1" sx={{ textAlign: "center", py: 4 }}>
                  {t("policies:noInstallmentsForPolicy")}
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={resetInstallmentsInfoState}
              color="primary"
              variant="text"
              style={{ borderRadius: "20px", padding: "6px 22px" }}
            >
              {t("policies:close")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Dialog for vehicle search */}
      <Dialog
        open={openVehicleSearch}
        onClose={resetVehicleSearchState}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t("policies:changeVehicle")}</DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2, mt: 2 }}>
            <Typography variant="subtitle2">{t("policies:searchVehicle")}</Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                placeholder={t("policies:vehiclePlate")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
              />
              <Button
                variant="outlined"
                onClick={handleSearchVehicles}
                disabled={!searchTerm}
              >
                {t("policies:search")}
              </Button>
            </Box>
            {localSearchedVehicles && localSearchedVehicles.length > 0 && (
              <Box sx={{ mt: 2, maxHeight: 200, overflowY: "auto" }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  {t("policies:vehiclesFoundLabel")}
                </Typography>
                <RadioGroup
                  value={selectedVehicle?._id || ""}
                  onChange={(e) => {
                    const vehicle = localSearchedVehicles.find(
                      (v) => v._id === e.target.value
                    );
                    setSelectedVehicle(vehicle);
                  }}
                >
                  {localSearchedVehicles.map((vehicle) => {
                    // Check and display vehicle data
                    const id = vehicle._id || "";
                    const regNumber =
                      vehicle.registrationNumber || vehicle.licensePlate || "";
                    const make = vehicle.carMakeEnglish || vehicle.make || "";
                    const model = vehicle.model || "";

                    return (
                      <FormControlLabel
                        key={id}
                        value={id}
                        control={<Radio />}
                        label={`${regNumber} - ${make} ${model}`}
                      />
                    );
                  })}
                </RadioGroup>
              </Box>
            )}
            {selectedVehicle && (
              <Box
                sx={{
                  p: 1,
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  backgroundColor: "#e8f5e9",
                  mt: 1,
                }}
              >
                <Typography variant="body2">
                  <strong>{t("policies:selectedVehicle")}</strong>{" "}
                  {selectedVehicle.carMakeEnglish || selectedVehicle.make || ""}{" "}
                  (
                  {selectedVehicle.registrationNumber ||
                    selectedVehicle.licensePlate ||
                    ""}
                  )
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={resetVehicleSearchState}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={handleSaveVehicle}
            style={{
              backgroundColor: "#0DC1CE",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
            disabled={!selectedVehicle}
          >
            {t("policies:save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for editing start date */}
      <Dialog
        open={openStartDateEdit}
        onClose={resetStartDateEditState}
        aria-labelledby="edit-start-date-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">{t("policies:editStartDate")}</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={1}>
            <Typography variant="subtitle1" gutterBottom>
              {t("policies:currentStartDate")}{" "}
              {editingPolicy?.policyStartDate
                ? formatDate(editingPolicy.policyStartDate)
                : t("policies:notSet")}
            </Typography>
            <MuiPickersUtilsProvider
              utils={CustomDateFnsUtils}
              locale={dateLocale}
            >
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd.MM.yyyy"
                margin="normal"
                id="start-date-picker"
                label={t("policies:colStartDate")}
                value={startDate ? new Date(startDate) : null}
                onChange={(date) => {
                  if (date) {
                    const year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    let day = date.getDate();

                    month = month < 10 ? `0${month}` : month;
                    day = day < 10 ? `0${day}` : day;

                    setStartDate(`${year}-${month}-${day}`);
                  } else {
                    setStartDate(null);
                  }
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                PopoverProps={{
                  PaperProps: {
                    style: {
                      fontFamily: "'Lexis-Medium', sans-serif",
                    },
                  },
                  disableEnforceFocus: true,
                  disableRestoreFocus: true,
                  disablePortal: false,
                  container: document.body,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  "data-calendar-container": "true",
                }}
                autoOk
                inputVariant="outlined"
                fullWidth
                InputProps={{
                  style: {
                    textAlign: "left",
                    fontFamily: "'Lexis-Medium', sans-serif",
                  },
                }}
                InputLabelProps={{
                  style: { fontFamily: "'Lexis-Medium', sans-serif" },
                }}
                maxDate={new Date("2099-12-31")}
              />
            </MuiPickersUtilsProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={resetStartDateEditState}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={handleSaveStartDate}
            style={{
              backgroundColor: "#0DC1CE",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
          >
            {t("policies:save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for editing end date */}
      <Dialog
        open={openEndDateEdit}
        onClose={resetEndDateEditState}
        aria-labelledby="edit-end-date-dialog"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">{t("policies:editEndDate")}</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={1}>
            <Typography variant="subtitle1" gutterBottom>
              {t("policies:currentEndDate")}{" "}
              {editingPolicy?.policyEndDate
                ? formatDate(editingPolicy.policyEndDate)
                : t("policies:notSet")}
            </Typography>
            <MuiPickersUtilsProvider
              utils={CustomDateFnsUtils}
              locale={dateLocale}
            >
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd.MM.yyyy"
                margin="normal"
                id="end-date-picker"
                label={t("policies:colEndDate")}
                value={endDate ? new Date(endDate) : null}
                onChange={(date) => {
                  if (date) {
                    const year = date.getFullYear();
                    let month = date.getMonth() + 1;
                    let day = date.getDate();

                    month = month < 10 ? `0${month}` : month;
                    day = day < 10 ? `0${day}` : day;

                    setEndDate(`${year}-${month}-${day}`);
                  } else {
                    setEndDate(null);
                  }
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                PopoverProps={{
                  PaperProps: {
                    style: {
                      fontFamily: "'Lexis-Medium', sans-serif",
                    },
                  },
                  disableEnforceFocus: true,
                  disableRestoreFocus: true,
                  disablePortal: false,
                  container: document.body,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  "data-calendar-container": "true",
                }}
                autoOk
                inputVariant="outlined"
                fullWidth
                InputProps={{
                  style: {
                    textAlign: "left",
                    fontFamily: "'Lexis-Medium', sans-serif",
                  },
                }}
                InputLabelProps={{
                  style: { fontFamily: "'Lexis-Medium', sans-serif" },
                }}
                maxDate={new Date("2099-12-31")}
              />
            </MuiPickersUtilsProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={resetEndDateEditState}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={handleSaveEndDate}
            style={{
              backgroundColor: "#0DC1CE",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
          >
            {t("policies:save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for editing amount */}
      <Dialog
        open={openAmountEdit}
        onClose={resetAmountEditState}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t("policies:editAmount")}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              label={t("policies:premium")}
              type="number"
              value={editPremium}
              onChange={(e) => setEditPremium(e.target.value)}
              fullWidth
              helperText={(() => {
                const baseCurrency =
                  editingPolicy?.currency === "EUR" ? "EUR" : "BGN";
                const dual = getPolicyDualAmounts(editPremium, baseCurrency);
                const primary = policyDisplayOrder[0];
                const secondary = policyDisplayOrder[1];
                const primaryAmount = dual?.[primary];
                const secondaryAmount = dual?.[secondary];
                if (toNumberOrNull(primaryAmount) === null) return "";
                if (toNumberOrNull(secondaryAmount) === null) return "";
                return `≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(secondary)}`;
              })()}
              InputProps={{
                endAdornment: (
                  <Typography variant="body2">
                    {getCurrencySymbol(
                      editingPolicy?.currency === "EUR" ? "EUR" : "BGN"
                    )}
                  </Typography>
                ),
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={resetAmountEditState}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={handleSaveAmount}
            style={{
              backgroundColor: "#0DC1CE",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
          >
            {t("policies:save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for deleting policy */}
      <Dialog
        open={openDeleteConfirm}
        onClose={cancelDeletePolicy}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">{t("policies:deletePolicy")}</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={2}>
            <Typography variant="body1" gutterBottom>
              {t("policies:confirmDeletePolicy")}
            </Typography>
            {policyToDelete && (
              <>
                <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>
                  <strong>{t("policies:kindLabel")}</strong>{" "}
                  {policyTypeLabel(policyToDelete.policyType, t) || "-"}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <strong>{t("policies:numberLabel")}</strong> {policyToDelete.policyNumber || "-"}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <strong>{t("policies:companyLabel")}</strong>{" "}
                  {policyToDelete.insuranceAgency || "-"}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  <strong>{t("policies:periodLabel")}</strong>{" "}
                  {formatDate(policyToDelete.policyStartDate) || "-"} -{" "}
                  {formatDate(policyToDelete.policyEndDate) || "-"}
                </Typography>
              </>
            )}
            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
              {t("policies:deleteIrreversible")}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={cancelDeletePolicy}
            color="primary"
            variant="text"
            style={{ borderRadius: "20px", padding: "6px 22px" }}
          >
            {t("policies:cancel")}
          </Button>
          <Button
            onClick={confirmDeletePolicy}
            style={{
              backgroundColor: "#f44336",
              color: "white",
              borderRadius: "20px",
              padding: "6px 22px",
            }}
          >
            {t("policies:delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  policies: state.amarantFields.policies,
  searchedVehicles: state.amarantFields.searchedVehicles,
  currentUser: state.login,
});

const mapDispatchToProps = (dispatch) => ({
  listPolicies: (payload) => dispatch(listPolicies(payload)),
  updatePolicy: (payload) => dispatch(updatePolicy(payload)),
  updateInstallment: (payload) => dispatch(updateInstallment(payload)),
  searchVehicle: (payload) => dispatch(searchVehicle(payload)),
  deletePolicy: (payload) => dispatch(deletePolicy(payload)),
  setSearchedVehicles: (payload) => dispatch(setSearchedVehicles(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PoliciesComponent);
